export enum RadioMenuENUM {
  about = 'about',
  comments = 'comments',
  gallery = 'gallery',
}
